/* eslint-disable angular/no-service-method */

const angular = require('angular')

module.exports = angular
  .module('hapara.shared.gainsight', [
    'angulartics',
    require('angular-ui-router'),
    require('../class-service/tdo-server.service'),
    require('../experiments/experiments.service'),
  ])
  .service('HaparaSharedGainSightService', BigQueryService)
  .service('BigQueryService', BigQueryService).name

function BigQueryService($q) {
  return {
    // The haparaview `_ah/api/hapara/v1/userevent` endpoint was retired as part
    // of the Python 2.7 deprecation; the service behind it did nothing, so
    // this call is now a no-op.
    /**
     * No-op stub retained for backward compatibility; immediately returns a resolved promise without side effects.
     */
    send() {
      return $q.when()
    },
  }
}

/* eslint-enable angular/no-service-method */
